import React from 'react'
import { SectionWrappSingle } from '../../lib-atomic-section'
import AuthContainer from '../../app-auth-container/default'
import Content from '../layout'

const index = (props) => {
  return (
    <SectionWrappSingle>
      <AuthContainer.Registration {...props}>
        <Content {...props} />
      </AuthContainer.Registration>
    </SectionWrappSingle>
  )
}

export default index
